<app-expansion-panel
  [titre]="peutSupprimer() ? 'Aptitude secondaire' : 'Aptitude principale'"
  [item]="index()"
  [isOpen]="true"
  [actions]="aptitudeActions"
>
  <div class="gap-md p-lg flex flex-col" [formGroup]="form()">
    <div hlmField>
      <div type="autocomplete" hlmButtonGroup>
        <brn-select class="inline-block" (valueChange)="setReferentiel($event)">
          <hlm-select-trigger>
            <hlm-select-value>
              <div *brnSelectValue="let value">
                {{ value?.nom ?? 'Tous les référentiels' }}
              </div>
            </hlm-select-value>
          </hlm-select-trigger>
          <hlm-select-content class="!min-w-max">
            <hlm-option [value]="undefined">
              <span>Tous les référentiels</span>
            </hlm-option>
            @for (referentiel of referentiels(); track referentiel.id) {
              <hlm-option [value]="referentiel">{{ referentiel.nom }}</hlm-option>
            }
          </hlm-select-content>
        </brn-select>
        <hlm-autocomplete
          id="autocomplete"
          [(search)]="search"
          [filteredOptions]="aptitudes() | trierPar: 'referentiel' : 'nom'"
          formControlName="aptitude"
          autocompleteSearchClass="border-stroke-neutral-medium"
        />
      </div>
    </div>

    <div class="gap-xxs flex flex-col">
      <label hlmLabel>Évaluation de l'aptitude</label>
      <hlm-radio-group class="gap-xxs flex flex-col" formControlName="estEvaluee">
        <div class="gap-xs flex items-center">
          <hlm-radio [id]="'yes-' + index()" [value]="true">
            <hlm-radio-indicator indicator />
          </hlm-radio>
          <label [for]="'yes-' + index()" hlmLabel>Oui, l'aptitude est évaluée</label>
        </div>
        <div class="flex items-center gap-3">
          <hlm-radio [id]="'no-' + index()" [value]="false">
            <hlm-radio-indicator indicator />
          </hlm-radio>
          <label [for]="'no-' + index()" hlmLabel>Non, l'aptitude n'est pas évaluée</label>
        </div>
      </hlm-radio-group>
    </div>
  </div>
</app-expansion-panel>
